import { DateTime, Interval } from "luxon"

export function formatISODate(dateTime, format = "MM/dd/yyyy hh:mm a") {
  return dateTime ? DateTime.fromISO(dateTime).toFormat(format) : null
}

export function getDateRange(rangeString) {
  const now = DateTime.now()
  let start, end

  switch (rangeString) {
    case "Today":
      start = now.startOf("day")
      end = now.endOf("day")
      break
    case "Yesterday":
      start = now.minus({ days: 1 }).startOf("day")
      end = now.minus({ days: 1 }).endOf("day")
      break
    case "This Week":
      start = now.startOf("week")
      end = now.endOf("week")
      break
    case "Last Week":
      start = now.minus({ weeks: 1 }).startOf("week")
      end = now.minus({ weeks: 1 }).endOf("week")
      break
    case "This Month":
      start = now.startOf("month")
      end = now.endOf("month")
      break
    case "Last Month":
      start = now.minus({ months: 1 }).startOf("month")
      end = now.minus({ months: 1 }).endOf("month")
      break
    default:
      throw new Error("Invalid range string")
  }

  return Interval.fromDateTimes(start, end)
}
